import React from "react";
import { Image, ImageProps } from "react-native";

export default function Img(props: ImageProps) {
  return <Image {...props} />;
}
